/**
 * LegacyCarousel Component
 * --------------------------------------------------------------------
 * This carousel is solely used for archived blog posts
 */

class LegacyCarousel extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      carousel: '[js-carousel]',
      slide: '[js-carousel-slide]',
      dots: '[js-carousel-dots]',
      prevButton: '[js-prev-button]',
      nextButton: '[js-next-button]'
    }

    this.options = {
      imagesLoaded: true,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      cellSelector: this.selectors.slide,
      wrapAround: true,
      on: {ready: this._onReady},
    }
  }

  connectedCallback() {
    const extendedOptions = this.dataset.options ? JSON.parse(this.dataset.options) : {}
    this.options = Object.assign(this.options, extendedOptions)
    this._initCarousel();

    const drawerId = this.dataset.drawerId;
    if (drawerId) {
      document.addEventListener(`${drawerId}:open`, this._bindDrawerOpen.bind(this));
    }

    const openSelector = this.dataset.openSelector;
    if (openSelector) {
      const openTriggers = document.querySelectorAll(openSelector);
      openTriggers.forEach((trigger) =>
        trigger.addEventListener('click', this._bindSlideSelect.bind(this))
      );
    }
    
    const modalId = this.dataset.modalId;
    if (modalId) {
      document.addEventListener(`${modalId}:open`, this._bindModalOpen.bind(this));
    }
  }

  // Bind Outer Modal open
  _bindModalOpen() {
    if(this.carousel) {
      this.carousel.resize();
    }
  }

  // Bind Outer drawer open
  _bindDrawerOpen() {
    if(this.carousel) {
      this.carousel.resize();
    }
  }

  // Bind slide open
  _bindSlideSelect(event) {
    const openSelector = this.dataset.openSelector;
    const openNode = event.target.closest(openSelector);
    if (openNode) {
      const slideIndex = openNode.dataset.index;
      this.carousel.select(slideIndex, false, true);
    }
  }

  // Initialize carousel
  _initCarousel() {
    this.dots = this.querySelector(this.selectors.dots);
    if (this.dots) {
      this.eachDot = this.dots.querySelectorAll('button');
    }
    this.prevButton = this.querySelector(this.selectors.prevButton);
    this.nextButton = this.querySelector(this.selectors.nextButton);

    if (typeof this.dataset.init !== 'undefined') {
      //do nothing initially, init at larger points
      enquire.register(theme.config.mediaQueries[this.dataset.init],{
        match: function(){
          this.carousel = new Flickity(this.querySelector(this.selectors.carousel), this.options)
          this._initCarouselControls();
        }.bind(this),
        unmatch: function(){
          if (this.carousel.element.classList.contains('flickity-enabled')) {
            this.carousel.destroy();
          }
        }.bind(this)
      })
    }else{
      this.carousel = new Flickity(this.querySelector(this.selectors.carousel), this.options)
      this._initCarouselControls();
    }
  }

  _initCarouselControls() {
    if(this.dots){
      this.carousel.on('change', this._updateDots)

      this.eachDot.forEach(dot => {
        dot.addEventListener('click', this._onDotClick)
      })
    }

    if(this.prevButton){
      this.prevButton.addEventListener('click', this._onPrevClick)
    }

    if(this.nextButton) {
      this.nextButton.addEventListener('click', this._onNextClick)
    }
  }

  //on carousel ready
  _onReady = () => {
    if (this.dots) {
      this._updateDots(0);
    }
  }

  //runs on carousel slide change to update selected dot
  _updateDots = index => {
    this.eachDot.forEach(dot => {
      dot.classList.remove('selected');
    })
    this.dots.querySelector('[data-index="'+ index +'"]').classList.add('selected')
  }

  _onDotClick = (e) => {
    var clickedElement = e.currentTarget;
    var targetIndex = clickedElement.dataset.index;
    this.carousel.select(targetIndex, true, true);
    this.eachDot.forEach(dot => {
      dot.classList.remove('selected');
    });
    clickedElement.classList.add('selected');
  }

  _onPrevClick = () => {
    this.carousel.previous()
  }

  _onNextClick = () => {
    this.carousel.next()
  }
}

if (!customElements.get('legacy-carousel')) {
  customElements.define('legacy-carousel', LegacyCarousel);
}